import React, { Component } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import { Loader } from 'semantic-ui-react'

const onLoadIframeHeight = (h) => {
  const iFrameID = document.getElementById('previewFrameWrapper')
  if (iFrameID) {
    iFrameID.setAttribute('style', `height: ${h}px`)
  }
}

const mockHTML = ''

// todo: convert to functional compoment
class PagePreview extends Component {
  constructor(props) {
    super(props)

    this.iframe = React.createRef()

    this.state = {
      isOpen: false,
      parsedHtml: this.props.html,
      iframeHeight: 0,
      previewMode: 'computer',
      isLoaded: false,
    }
  }

  componentDidMount() {
    const { parsedHtml } = this.state
    this.open(parsedHtml)
    window.addEventListener('message', this.resizeIframe)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.resizeIframe)
  }

  resizeIframe = (e) => {
    this.setState(
      {
        iframeHeight: e.data.height,
        isLoaded: true,
      }
    )
    e.data.height && onLoadIframeHeight(e.data.height)
  }

  onEscKey(e) {
    e.key === 'Escape' && this.close()
  }

  changeMode(mode) {
    this.setState(() => ({
      previewMode: mode
    }))
  }

  open(html) {
    this.openModal()
    this.setState({
      parsedHtml: html,
      previewMode: 'computer'
    })
  }

  openModal() {
    this.setState({
      isOpen: true
    })
  }

  close = () => {
    this.setState({
      isOpen: false,
      parsedHtml: null,
      iframeHeight: null
    })
  }

  render() {
    const {
      isOpen,
      parsedHtml,
      isLoaded,
      previewMode,
    } = this.state

    const finalHtml = parsedHtml && parsedHtml.replace('</body>', `${mockHTML}<script>setTimeout(() => parent.postMessage({height: window.document.body.scrollHeight}, '*') , 800 );</script></body>`)

    return isOpen
      ? (
        <div>
          <div className={`previewViewport previewMode ${isLoaded ? 'visible' : 'hidden'}`}>
            {previewMode === 'phone' && <div />}
            {previewMode === 'tablet' && <div />}
            <div>
              {previewMode === 'computer' && <span className="browserToolbar"><div /></span>}
              <Scrollbars
                className="previewScollable"
                autoHide
                autoHeight
                autoHeightMax={800}
                autoHeightMin={500}
              >
                <div id="previewFrameWrapper" className="iframeWrapper">
                  <iframe
                    id="previewFrame"
                    className="iframe"
                    ref={this.iframe}
                    width="100%"
                    height="100%"
                    frameBorder={0}
                    scrolling="no"
                    srcDoc={finalHtml}
                    title="preview"
                  />
                </div>
              </Scrollbars>
            </div>
          </div>
          <div className={`${isLoaded ? 'hidden' : 'visible'}`}>
            <Loader active></Loader>
          </div>
        </div>
      )
      : <div />
  }
}

export default PagePreview
